import { useCallback, useState } from "react"

export type CategoriesState = Map<string, string>

export type CategoryData = {
  "reportingCategories.id": string
  "reportingCategories.name": string
}

export type UseCategoriesState = {
  state: CategoriesState
  setState: React.Dispatch<React.SetStateAction<CategoriesState>>
  onAddCategories: (list: CategoryData[]) => void
}

export const INITIAL_CATEGORIES_STATE: CategoriesState = new Map<
  string,
  string
>()

export const useCategoriesState = (): UseCategoriesState => {
  const [state, setState] = useState<CategoriesState>(INITIAL_CATEGORIES_STATE)

  const onAddCategories = useCallback((list: CategoryData[]) => {
    setState(prevState => {
      // Create new map from previous to keep all existing values.
      const categoriesMap = new Map<string, string>(prevState)

      // Add new data.
      list.forEach(item => {
        categoriesMap.set(
          item["reportingCategories.id"],
          item["reportingCategories.name"]
        )
      })

      return categoriesMap
    })
  }, [])

  return {
    state,
    setState,
    onAddCategories
  }
}
